var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page-loader position-fixed"},[_c('div',{staticClass:"vh-center position-absolute z-1 load-round"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1),_c('div',{staticClass:"full-load-text position-absolute d-none"},[_vm._v(" Upgrading your plan ... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }